import ApiService from '@/services/api.service'

export default {

    /**
     * @param {ReadUrlsByRequest} readUrlsByRequest
     * @returns {Promise<Object>}
     */
    async readUrlsByDomain (readUrlsByRequest) {
        return ApiService.get('/v2/elastic-search/urls/by-domain', readUrlsByRequest.toJson())
    },

    /**
     * @param {ReadUrlsByRequest} readUrlsByRequest
     * @returns {Promise<Object>}
     */
    async readUrlsByKeyword (readUrlsByRequest) {
        return ApiService.get('/v2/elastic-search/urls/by-keyword', readUrlsByRequest.toJson())
    },

    /**
     * @param {ReadUrlsByRequest} readUrlsByRequest
     * @returns {Promise<Object>}
     */
    async readUrlsByUrl (readUrlsByRequest) {
        return ApiService.get('/v2/elastic-search/urls/by-url', readUrlsByRequest.toJson())
    },

    /**
     * @param {ReadUrlsByRequest} readUrlsByRequest
     * @returns {Promise<Object>}
     */
    async readUrlsByThematic (readUrlsByRequest) {
        return ApiService.get('/v2/elastic-search/urls/by-thematic', readUrlsByRequest.toJson())
    },

    /**
     * @param {ReadUrlsByRequest} readUrlsByRequest
     * @returns {Promise<Object>}
     */
    async readUrlsByFavorites (readUrlsByRequest) {
        return ApiService.get('/v2/elastic-search/urls/by-favorites', readUrlsByRequest.toJson())
    },
}